module.exports = __webpack_public_path__ + "img/1.ea946c9.jpg";